import { Observable } from 'rxjs';
import { CONTACTS } from '../../app.consts';
import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import {
  AddContactRequestModel,
  AddContactResponseModel,
} from '../../models/contacts.model';
import { AuthService } from '../../services/auth.service';
import { mapPhoneNumber } from 'src/app/utils/format-phone';

@Injectable()
export class ContactsApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  addContact(
    body: AddContactRequestModel
  ): Observable<AddContactResponseModel> {
    const parsedContact = body.phoneNumber
      ? {
          ...body,
          phoneNumber: mapPhoneNumber(body.phoneNumber),
        }
      : body;
    return this.http.post<AddContactResponseModel>(
      `${this.apiUrl}${CONTACTS}`,
      parsedContact,
      this.authHeader
    );
  }
}
